var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.275,
    y: 0.275,
    width: 21.45,
    height: 21.45,
    rx: 10.725,
    stroke: "#FB8A06",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#37990jwtsa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9supqlylqb)",
    fill: "#FB8A06"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16 15.404h5.143l-2.475-1.65H4.161a.825.825 0 0 0 0 1.65zM12.39 13.754H7.82l2.384 1.59 2.186-1.59zM6.911 13.202h6.865a3.58 3.58 0 0 0-3.565-3.3h-3.3a3.58 3.58 0 0 0-3.564 3.3H6.91zm3.85-1.65h.55v.55h-.55v-.55zm-.825-1.1h.55v.55h-.55v-.55zm-.825 1.1h.55v.55h-.55v-.55zm-.825-1.1h.55v.55h-.55v-.55zm-.825 1.1h.55v.55h-.55v-.55zm-.825-1.1h.55v.55h-.55v-.55zm-.825 1.1h.55v.55h-.55v-.55zM4.16 15.953h-.824v.825c0 .456.37.825.825.825h8.8c.455 0 .825-.37.825-.825v-.825H4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.787 9.668c.27.112.529.253.77.42l-.066-.993.55-.036.1 1.517a4.11 4.11 0 0 1 1.195 2.901.275.275 0 0 1-.275.275h-.007a1.347 1.347 0 0 1 0 1.65h.007c.152 0 .275.123.275.275v1.1a1.36 1.36 0 0 1-.282.825h2.777l.784-10.45h-6.008l.18 2.516zm1.174-1.71.04.55-.55.039-.039-.55.549-.04zM15.16 5.777h-4.4v.825h7.7v-.825h-3.3zM14.336 2.203h.55v3.025h-.55V2.203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.25 13.809-2.193 1.595h1.904a.823.823 0 0 0 .289-1.595z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "37990jwtsa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 2.203)",
    d: "M0 0h15.4v15.4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9supqlylqb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 2.203)",
    d: "M0 0h15.4v15.4H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodDelivery);
export default __webpack_public_path__ + "static/media/food-delivery.91a4c7d3.svg";
export { ForwardRef as ReactComponent };